import { ReactElement, useEffect, useRef } from 'react';
import { MapContainer } from '../Map/MapContainer';
import { MapContent } from '../Map/MapContent';
import { useThermalComfortDataContext } from '../contexts/ThermalComfortDataContext';

interface ThermalComfortMapProps {
  hasThermalComfort: boolean;
  loading: boolean;
}

export function ThermalComfortMap({
  hasThermalComfort,
  loading,
}: Readonly<ThermalComfortMapProps>): ReactElement {
  const { units, loading: loadingUnits } = useThermalComfortDataContext();
  const isFirstUnitsRender = useRef(true);

  const disabledComponents = loadingUnits || isFirstUnitsRender.current || !hasThermalComfort;

  useEffect(() => {
    if (loadingUnits && isFirstUnitsRender.current) {
      isFirstUnitsRender.current = false;
    }
  }, [loadingUnits]);

  useEffect(() => () => {
    isFirstUnitsRender.current = true;
  }, []);

  return (
    <MapContainer
      loading={loading}
      disabledTooltip={disabledComponents}
    >
      <MapContent
        type="thermalComfort"
        disabled={disabledComponents}
        units={units}
      />
    </MapContainer>
  );
}
